function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "partners");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M32.94,9.92,27.68.26a.48.48,0,0,0-.3-.24.51.51,0,0,0-.38,0L23.49,2a.51.51,0,0,0-.2.68L28.4,12,26.83,14.3A5.61,5.61,0,0,1,25,16L16.09,20.8a1,1,0,0,1-1.36-.4,1,1,0,0,1,.38-1.34l3.1-1.69a.5.5,0,1,0-.48-.88l-3.08,1.68,0,0-1.72.93a1,1,0,1,1-1-1.75l4.83-2.63a.5.5,0,0,0-.47-.88l-4.84,2.63h0l-1.75,1a1,1,0,0,1-1.44-1.16,1,1,0,0,1,.48-.59l6.59-3.59a.5.5,0,0,0-.48-.88L10,13.85a1,1,0,0,1-1.36-.4,1,1,0,0,1,.4-1.35l2-1.08a.49.49,0,0,0,.2-.68.5.5,0,0,0-.68-.2l-2,1.08a2,2,0,0,0-.8,2.71,2,2,0,0,0,.71.75l-.24.13a2,2,0,0,0-1,1.19,2,2,0,0,0,1.35,2.48,2,2,0,0,0,1.53-.16l.23-.13a2,2,0,0,0,.24,1,2,2,0,0,0,2.72.8l.23-.13a2,2,0,0,0,.24,1,2,2,0,0,0,1.2,1,1.77,1.77,0,0,0,.56.08,2,2,0,0,0,1-.24l8.85-4.82a6.65,6.65,0,0,0,2.23-2l1.68-2.41,3.41-1.86A.5.5,0,0,0,32.94,9.92ZM29.19,11.4,24.41,2.61,27,1.18,31.82,10ZM4.94,12.78l1.25-5,1.26-5,2.68-.6a5.37,5.37,0,0,1,2.52,0L20.5,4.09a1,1,0,0,1,.73,1.21A1,1,0,0,1,20,6L15.65,4.94a.5.5,0,0,0-.38.06.52.52,0,0,0-.23.31A3.5,3.5,0,0,1,10.8,7.86l-1-.24A.51.51,0,0,0,9.22,8a.51.51,0,0,0,.37.6l1,.24A4.48,4.48,0,0,0,14,8.32,4.54,4.54,0,0,0,15.87,6l3.9,1a2,2,0,1,0,1-3.88L12.89,1.17a6.52,6.52,0,0,0-3,0L7,1.78,3.27.84A.52.52,0,0,0,2.89.9a.48.48,0,0,0-.22.3L0,11.88a.51.51,0,0,0,.06.38.56.56,0,0,0,.31.23l3.77.93,2.23,1.91a.5.5,0,0,0,.71-.06.5.5,0,0,0-.06-.7ZM3.52,1.93l2.91.72L4,12.36l-2.91-.72Z"
})));

var SvgPartners = function SvgPartners(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 33 21.92",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPartners, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partners.7eba0d49.svg";
export { ForwardRef as ReactComponent };